<template>
  <!-- 底部 -->
  <div id="footer">
      <div class="xh_link">
        <h3>广州市台资企业协会</h3>
        <div class="left_link">
          <ul>
            <li>
              <a href="/home">首页</a>
            </li>
            <li @click="goToPage(3)">
              <a >办事指南</a>
            </li>
            <li>
              <a @click="skipToPage()">加入会员</a>
            </li>
          </ul>
        </div>
        <div class="right_link">
          <ul>
            <li>
              <a  @click="goToPage(2)">协会资讯</a>
            </li>
            <li>
              <a  @click="goToPage(4)">政策法规</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="fwzc">
        <h3>服务与支持</h3>
        <ul>
            <li>
              联系电话：020-12345678
            </li>
            <li>
              工作时间：9:00-18:00（工作日）
            </li>
          </ul>
      </div>
      <div class="qrcode">
        <img src="../assets/image20.png" alt="">
        <p>扫码二维码关注我们</p>
      </div>
    </div>
</template>
<script>
import eventBus from '@/utils/event_bus';
export default {
  name: 'FooterComponent',
  methods: {
    goToPage(idx) {
      eventBus.$emit('navChange', idx);
      this.$router.push({ name: 'home', query: { idx: idx } });
    },
    skipToPage(){
      window.open('https://duud.cn/app/index.php?i=767&c=entry&do=detail&m=tech_superarticle&id=324','_blank');
    }
  }
}
</script>
<style scoped>
@import "../style/common.css";
@import "../style/footer.css";
</style>